import { gql } from '@apollo/client';
import { chakra, HStack, Tooltip } from '@chakra-ui/react';
import { t } from 'i18next';
import { PropsWithChildren } from 'react';
import { CellProps } from 'react-table';
import { LandscapeIcon, WarningIcon } from '~components/ui/icons';
import { PlaylistTable_PlaylistFragment } from '../__generated__/PlaylistTable.graphql';
import { UsedByCell_PlaylistFragment } from './__generated__/UsedByCell.graphql';

export function UsedByCell({
  value,
}: PropsWithChildren<CellProps<PlaylistTable_PlaylistFragment, UsedByCell_PlaylistFragment>>) {
  const syncedCount = value.syncedDisplays.length;
  const outOfSyncCount = value.outOfSyncDisplays.length;
  const syncingCount = value.syncingDisplays.length;

  return (
    <HStack spacing="4">
      <HStack spacing="2">
        <LandscapeIcon height="6" width="6" />
        <chakra.span display="block">{syncedCount}</chakra.span>
      </HStack>
      {outOfSyncCount > 0 && (
        <Tooltip label={`${outOfSyncCount} ${t('outOfSync')}`}>
          <HStack spacing="2">
            <WarningIcon height="6" width="6" color="orange.400" />
            <chakra.span display="block">
              {outOfSyncCount} {t('outOfSync')}
            </chakra.span>
          </HStack>
        </Tooltip>
      )}
      {syncingCount > 0 && (
        <Tooltip label={`${syncingCount} ${t('syncing')}`}>
          <HStack spacing="2">
            <WarningIcon height="6" width="6" color="orange.400" />
            <chakra.span display="block">
              {syncingCount} {t('syncing')}
            </chakra.span>
          </HStack>
        </Tooltip>
      )}
    </HStack>
  );
}

UsedByCell.graphql = {
  fragments: {
    UsedByCell_playlist: gql`
      fragment UsedByCell_playlist on Playlist {
        id
        syncedDisplays: displays(filter: { state: SYNCED }) {
          id
        }
        outOfSyncDisplays: displays(filter: { state: OUT_OF_SYNC }) {
          id
        }
        syncingDisplays: displays(filter: { state: SYNCING }) {
          id
        }
      }
    `,
  },
};
